export enum AsyncStorageKeys {
  UTM_DATA = 'oeapp.utmData',
  BRANCH_PARAMS = 'oeapp.branchParams',
}
